import * as React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { FontAwesome } from '@expo/vector-icons';
import Colors from "../utilities/Color.js";
import { toggleFavoriteOffer } from "../redux/actions/OfferActions.js";

export default function favouriteIcon({isFavorite, offerId}) {
  const [showFavourited, isFavourited] = React.useState(false);

  React.useEffect(() => {
    isFavourited(isFavorite);
  }, []);

  return (
    <View style={styles.favouriteIconContainer}>
      <TouchableOpacity
        style={styles.iconContainer}
        onPress={() => {
          toggleFavoriteOffer(offerId);
          isFavourited(!showFavourited)
        }}
      >
        <FontAwesome name={!showFavourited ? "bookmark-o" : "bookmark"} size={22} color={Colors.WHITE} />
      </TouchableOpacity>
    </View>
  );
}
const styles = StyleSheet.create({})